import * as THREE from "three";
import RegularDie from "./RegularDie";
import {DiceManager, DiceD8} from "threejs-dice";
import CANNON from "cannon";

const getD8Geometry = (radius) => {
    const world = new CANNON.World();
    DiceManager.setWorld(world);
    const d8Model = new DiceD8({ size: radius });
    d8Model.chamfer = 1;
    return d8Model.getGeometry();
};

export default class D8 extends RegularDie {
    constructor(radius = 0.2, options = {}) {
        const geometry = getD8Geometry(radius);
        options.overrideShape = options.overrideShape || geometry.cannon_shape;
        super(options);

        this.radius = radius;
        this.geometry = geometry;
        this.textMargin = 1.2;
        this.faces = [" ", " ", "1", "2", "3", "4", "5", "6", "7", "8"];

        this.create();
    }

    solveFaceUp(index) {
        return this.faces[index];
    }
}
